var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"988d56115ab9170c4a5d4f012e993754e8444c64"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["justsearch-public-front@arcanite"]={id:"988d56115ab9170c4a5d4f012e993754e8444c64"};
      